import { useSelector } from 'react-redux'
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { MdOutlineMoreHoriz } from "react-icons/md";
import { useDispatch } from 'react-redux';
import { showModal } from '../../features/modal/modalSlice';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useState } from 'react';


const Container = styled.div`
  width: 100%;
  height: 100%;
  color: ${({theme}) => theme.mainTextColor};
  .wrapper{
    width: 100%;
    padding: 30px;
    .content{
      
      .report-list{
        display: flex;
        flex-direction: column;
        gap: 15px;
        .report-container{
          display: flex;
          align-items: center;
          gap: 20px;
          background-color: var(--color-light);
          padding: 10px;
          border-radius: 8px;
          width: 500px;
          cursor: pointer;
          p{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
          }
        }
      }
    }
  }
  
`
 
const initialRaporList = [
  {
    id:0,
    modalValue:"sevkiyatRaporu",
    text:"Sevkiyat Raporu"
  },
  {
    id:1,
    modalValue:"yukKaydiRapor",
    text:"Yük Kaydı Raporu"
  },
  {
    id:2,
    modalValue:"ortalamaAracTedarikSure",
    text:"Ortalama Araç Tedarik Süreleri Raporu"
  },
  {
    id:3,
    modalValue:"arsivYukveGerecke",
    text:"Arşive Alınan Yük Kayıtları ve Gerekçeleri Raporu"
  },
  {
    id:4,
    modalValue:"yuklemeSureRapor",
    text:"Yükleme Süreleri Raporu"
  },
  {
    id:5,
    modalValue:"bosaltmaSureRapor",
    text:"Boşaltma Süreleri Raporu"
  },
  {
    id:6,
    modalValue:"enUzunSureliYukleme",
    text:"En Uzun Süreli Yüklemeler Raporu"
  },
  {
    id:7,
    modalValue:"enUzunSureliBosaltma",
    text:"En Uzun Süreli Boşaltmalar Raporu"
  }
]

const Raporlar = () => {
  const {theme} = useSelector((state) => state.layout)
  const dispatch = useDispatch()
  const [raporList, setRaporList] = useState(initialRaporList)

  const handleOnDragEnd = (result) => {
    if (!result.destination) return; 

    const items = Array.from(raporList);
    const [reorderedItem] = items.splice(result.source.index, 1); 
    items.splice(result.destination.index, 0, reorderedItem); 

    setRaporList(items);
  };

  return (
    <Container theme={theme}>
      <PageTopTitle title={"Raporlar"} position='sticky' />
      <div className="wrapper">
        <div className="content">
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="report-list">
              {(provided) => (
                <div className="report-list" {...provided.droppableProps} ref={provided.innerRef}>
                  {raporList.map((item, index) => (
                    <Draggable key={item.id} draggableId={item.modalValue} index={index}>
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          onClick={() => dispatch(showModal(item.modalValue))}
                          className="report-container"
                        >
                          <MdOutlineMoreHoriz />
                          <p>{item.text}</p>
                        </div>
                      )}
                    </Draggable>
                  ))}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>
    </Container>
  );
}

export default Raporlar